import VueRouter, { RouteConfig } from 'vue-router'

const NoticeCenter = () => import('../views/NoticeCenter.vue')
const NoticeList = () => import('../views/NoticeList.vue')
const NoticeAttacheFileDownloadPage = () => import('../views/NoticeAttacheFileDownload.vue')
export const noticeCenterRoute: RouteConfig = {
  path: '/notice-center',
  name: 'notice_center',
  component: NoticeCenter,
  meta: {
    title: '消息中心',
  },
}

export const noticeListRoute: RouteConfig = {
  path: '/notice-list',
  name: 'notice_list',
  component: NoticeList,
  props: (route) => ({ category: route.query.category, title: route.query.title }),
}

export const noticeAttacheFileDownloadRoute: RouteConfig = {
  path: '/notice-attache-file-download',
  name: 'notice_attache_file_download',
  component: NoticeAttacheFileDownloadPage,
  props: (route) => ({ file: route.query.file, fileType: route.query.fileType }),
  meta: {
    title: '查看详情',
  },
}

export default [noticeCenterRoute, noticeListRoute, noticeAttacheFileDownloadRoute]

export function navigateToNoticeCenter(router: VueRouter) {
  router.push({ name: noticeCenterRoute.name })
}

export function navigateToNoticeList(router: VueRouter, category: string, title: string) {
  router.push({ name: noticeListRoute.name, query: { category, title } })
}
